import { sanitizeCustomFields } from '../utils/sanitizeCustomFields';

export type BizneoCountry = 'spain' | 'colombia';

export type ConnectBizneoArgs = {
  body: { apiKey: string; baseUrl: string };
  noAutoLogout: boolean;
  subsidiary?: string;
};

export type BizneoCredentialsResponse = {
  message: string;
};

export type BizneoConfig = {
  country: BizneoCountry;
  companyId?: number;
  includeAbsenceTypes: number[];
  customFields?: Record<string, string>;
};

export type BizneoValues = {
  subsidiary: string;
  apiKey: string;
  baseUrl: string;
  country: BizneoCountry | '';
  companyId: string | null;
  includeAbsenceTypes: string[];
  withCustomFields: boolean;
  customFields: Record<string, string | null | undefined> | null | undefined;
};

export const COUNTRY_OPTIONS: Array<{ label: string; value: BizneoCountry }> = [
  { label: 'España', value: 'spain' },
  { label: 'Colombia', value: 'colombia' }
];

export const credentialInputList: Array<{ label: string; name: 'apiKey' | 'baseUrl' }> = [
  {
    label: 'integrations.bizneo.api key',
    name: 'apiKey'
  },
  {
    label: 'integrations.bizneo.base url',
    name: 'baseUrl'
  }
];

export const bizneoInitialValues: BizneoValues = {
  subsidiary: '',
  apiKey: '',
  baseUrl: '',
  country: '',
  companyId: '',
  includeAbsenceTypes: [],
  withCustomFields: false,
  customFields: null
};

const isPositiveInteger = (value: string | number | null | undefined): boolean => {
  if (value == null || value === '') {
    return false;
  }

  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0;
};

export const isBizneoConfigComplete = (formData: BizneoValues): boolean =>
  Boolean(formData.subsidiary && formData.country);

export const mapFormDataToBizneoConfig = (formData: BizneoValues): BizneoConfig | null => {
  if (!isBizneoConfigComplete(formData)) {
    return null;
  }

  const config: BizneoConfig = {
    country: formData.country as BizneoCountry,
    includeAbsenceTypes: (formData.includeAbsenceTypes ?? []).map(Number).filter(id => !Number.isNaN(id)),
    customFields: formData.withCustomFields ? sanitizeCustomFields(formData.customFields) ?? {} : {}
  };

  if (isPositiveInteger(formData.companyId)) {
    config.companyId = Number(formData.companyId);
  }

  return config;
};

export const mapParamOptionsToSelect = (options: Array<{ id: string; label: string }>) =>
  options.map(option => ({
    label: option.label,
    value: option.id
  }));
